import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

type BaseProps = {
  stretch: Props["stretch"];
  horizontalAlign: Props["horizontalAlign"];
};

const Base = styled.div<BaseProps>`
  display: flex;
  justify-content: center;
  width: ${p => (p.stretch ? "100%" : null)};
  align-items: ${p =>
    p.horizontalAlign === "center" ? "center" : "flex-start"};

  &:not(:last-child) {
    margin-bottom: ${select.space(3)};
  }
`;

const Left = styled.div`
  margin-right: 15%;
  flex: 1 0;

  & > *:nth-child(2) {
    margin-top: ${select.space(0)};
  }

  & > * {
    display: block;
  }
`;

const Right = styled.div<{ width: Props["rightWidth"] }>`
  width: ${p => p.width};

  & [data-testid="checkbox"] {
    margin-left: 32px;
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  horizontalAlign?: "center" | "top";
  left: React.ReactNode;
  right: React.ReactNode;
  rightWidth?: string | number;
  stretch?: boolean;
};

function FormLabelRow(
  {
    style,
    className,
    horizontalAlign = "center",
    left,
    right,
    rightWidth,
    stretch
  }: Props,
  ref: any
) {
  return (
    <Base
      ref={ref}
      className={className}
      stretch={stretch}
      horizontalAlign={horizontalAlign}
      style={style}
    >
      <Left>{left}</Left>
      <Right width={rightWidth}>{right}</Right>
    </Base>
  );
}

export default React.forwardRef(FormLabelRow);
